module.exports = __webpack_public_path__ + "img/block-6-left-mobile.7b92a928.jpg";